import cn from 'classnames'
import {FC} from 'react'

import {getIconSize, IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

type RadioButtonMarkProps = {
  isChecked: boolean
  size?: IconSize
}

export const RadioButtonMark: FC<React.PropsWithChildren<RadioButtonMarkProps>> = ({
  isChecked,
  size = IconSize.medium,
}) => {
  const iconSize = getIconSize(size)

  return (
    <>
      <span className={cn('radio', isChecked && 'checked')} />

      <style jsx>{`
        .radio {
          display: flex;
          align-items: center;
          justify-content: center;
          height: ${iconSize};
          width: ${iconSize};
          flex: 0 0 ${iconSize};
          background-color: ${theme.palette.background.default};
          box-shadow: inset 0px 0px 0px 1px ${theme.palette.gray[300]};
          border-radius: 50%;
        }
        .radio:not(.checked):hover {
          background-color: ${theme.palette.gray[50]};
        }
        .checked {
          background-color: ${theme.palette.gray[900]};
          box-shadow: none;
        }
        .checked::after {
          content: '';
          position: absolute;
          width: calc(${iconSize} / 2 - 2px);
          height: calc(${iconSize} / 2 - 2px);
          border-radius: 50%;
          background-color: ${theme.palette.background.default};
        }
        .checked:hover {
          background-color: ${theme.palette.gray[600]};
        }
      `}</style>
      <style jsx global>{`
        input:focus + .radio-button .radio {
          box-shadow: inset 0px 0px 0px 1px ${theme.palette.gray[300]},
            0px 0px 0px 4px ${theme.palette.gray[100]};
        }
        input:focus + .radio-button .checked {
          box-shadow: 0px 0px 0px 4px ${theme.palette.gray[100]};
        }
      `}</style>
    </>
  )
}
